// 判断值是否为空
const isNullOrEmpty = function (val) {
  if (val == null || val == '' || typeof val == undefined) {
    return true
  } else {
    return false
  }
}

// 日期格式化
const timeFormat = (value, format) => {
  if (!value) {
    return value
  }
  if (format.length === 1) {
    return value.replace(/-/g, format)
  }
  let date = new Date(value.replace(/-/g, '/'))
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  let h = date.getHours()
  let min = date.getMinutes()
  let s = date.getSeconds()
  let result = ''
  if (format == undefined) {
    result = `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d} ${
      h < 10 ? '0' + h : h
    }:${min < 10 ? '0' + min : min}:${s < 10 ? '0' + s : s}`
  }
  if (format == 'yyyy-mm-dd') {
    result = `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`
  }
  if (format == 'yyyy-mm') {
    result = `${y}-${m < 10 ? '0' + m : m}`
  }
  if (format == 'mm-dd') {
    result = ` ${mm < 10 ? '0' + mm : mm}:${ddmin < 10 ? '0' + dd : dd}`
  }
  if (format == 'hh:mm') {
    result = ` ${h < 10 ? '0' + h : h}:${min < 10 ? '0' + min : min}`
  }
  if (format == 'yyyy') {
    result = `${y}`
  }
  return result
}

/**
 * 两个时间相距 取时间格式 00天00时00分
 */
const getDistanceTime = (value, date1 = 'now') => {
  if (date1 === 'now') {
    date1 = new Date().getTime()
  } else {
    date1 = Date.parse(date1.replace(/-/g, '/'))
  }
  value = Date.parse(value.replace(/-/g, '/'))
  // 计算两个日期之间相差的毫秒数的绝对值
  // var distance = Math.abs(value - date1);
  var distance = value - date1
  distance = distance > 0 ? distance : 0
  var days = Math.floor(distance / (24 * 3600 * 1000))
  var leave1 = distance % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = handleDate(Math.floor(leave1 / (3600 * 1000)))
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = handleDate(Math.floor(leave2 / (60 * 1000)))
  return `${days > 0 ? days + '天' : ''}${hours > 0 ? hours + '小时' : ''}${
    minutes > 0 ? minutes + '分钟' : ''
  }`
}

// 处理月/日的显示格式
const handleDate = (date) => {
  return ('00' + date).slice(String(date).length)
}

// 距离格式化
const formatDis = (val) => {
  if (val > 1000) {
    return Number((val / 1000).toFixed(1)) + 'KM'
  }
  return val + 'M'
}

// 课程状态格式化
const courseState = (val) => {
  return val <= -1000 ? '已过期' : val > 0 ? '预约' : '已满'
}

// const weekArr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
// 日期得到 “今天” “明天” 周几
const formatDayName = (val) => {
  const time = val.split(' ')[1] ? ' ' + val.split(' ')[1] : ''
  let od = new Date(val.replace(/-/g, '/'))
  od = new Date(od.getFullYear(), od.getMonth(), od.getDate())
  let td = new Date()
  td = new Date(td.getFullYear(), td.getMonth(), td.getDate())
  const xc = (od - td) / 1000 / 60 / 60 / 24
  if (xc === -2) {
    return '前天' + time
  } else if (xc === -1) {
    return '昨天' + time
  } else if (xc === 0) {
    return '今天' + time
  } else if (xc === 1) {
    return '明天' + time
  }
  return val.slice(5)
}
const filterNumber = (num) => {
  if (num <= 9999) {
    return num
  } else {
    return (num / 10000).toFixed(2) + 'w'
  }
}
// 会员卡状态格式化
const cardState = (val) => {
  switch (val) {
    case 0:
      return '待激活'
    case 1:
      return '使用中'
    case 2:
      return '停卡中'
    case 3:
      return '已过期'
    default:
      return ''
  }
}
export {
  isNullOrEmpty,
  timeFormat,
  getDistanceTime,
  handleDate,
  formatDis,
  courseState,
  formatDayName,
  cardState
}
